import { LOCALES } from 'i18n/locales';

export const floatingDrawPanelIntl = {
    [LOCALES.ENGLISH]: {
        'floatingDrawPanel.distance': 'Distance',
        'floatingDrawPanel.metres': 'm',
        'floatingDrawPanel.kilometres': 'km',
        'floatingDrawPanel.miles': 'miles',
        'floatingDrawPanel.confirm': 'Confirm',
        'floatingDrawPanel.delete': 'Delete point',
        'floatingDrawPanel.move': 'Move panel',
        'floatingDrawPanel.ariaLabel': 'Line drawing editing panel',
        'floatingDrawPanel.tooltip.dragToMove': 'Click and drag to move this panel',
        'floatingDrawPanel.tooltip.reduceBuffer': 'Reduce width to finish drawing',
        'floatingDrawPanel.tooltip.reduceLength': 'Reduce total length to finish drawing',
        'floatingDrawPanel.tooltip.outsideServiceArea': 'Ensure your line is entirely within your service area.'
    },
    [LOCALES.WELSH]: {
        'floatingDrawPanel.distance': '[Distance]',
        'floatingDrawPanel.metres': 'm',
        'floatingDrawPanel.kilometres': 'km',
        'floatingDrawPanel.miles': '[miles]',
        'floatingDrawPanel.confirm': '[Confirm]',
        'floatingDrawPanel.delete': '[Delete point]',
        'floatingDrawPanel.move': '[Move panel]',
        'floatingDrawPanel.ariaLabel': '[Line drawing editing panel]',
        'floatingDrawPanel.tooltip.dragToMove': '[Click and drag to move this panel]',
        'floatingDrawPanel.tooltip.reduceBuffer': '[Reduce width to finish drawing]',
        'floatingDrawPanel.tooltip.reduceLength': '[Reduce total length to finish drawing]',
        'floatingDrawPanel.tooltip.outsideServiceArea': '[Ensure your line is entirely within your service area.]'
    }
};
